<template>
  <div class="data-manage">
    <star-condition-layout :onSearch="handleSearch" :onReset="handleReset" :loading="loading">
      <star-condition-cell label="标题">
        <a-input v-model="search.title" placeholder="请输入标题" allowClear />
      </star-condition-cell>
      <star-condition-cell label="内容">
        <a-input v-model="search.searchContent" placeholder="请输入内容" allowClear />
      </star-condition-cell>
      <star-condition-cell label="站点类型">
        <SpiderTypeSelect v-model="search.spiderClassType" />
      </star-condition-cell>
      <star-condition-cell label="语言">
        <LangSelect v-model="search.langCode" />
      </star-condition-cell>
      <star-condition-cell label="国家">
        <CountrySelect v-model="search.countryCode" />
      </star-condition-cell>
      <star-condition-cell label="站点名称">
        <a-input v-model="search.spiderName" placeholder="请输入站点名称" allowClear />
      </star-condition-cell>
      <star-condition-cell label="站点Id">
        <a-input v-model="search.spiderId" placeholder="请输入站点Id" allowClear />
      </star-condition-cell>
      <star-condition-cell label="发布日期">
        <a-range-picker
          style="width: 100%"
          v-model="search.publishTime"
          :show-time="{ format: 'HH:mm:ss' }"
          value-format="YYYY-MM-DD HH:mm:ss"
          :placeholder="['开始日期', '结束日期']"
        />
      </star-condition-cell>

      <star-condition-cell label="采集日期">
        <a-range-picker
          style="width: 100%"
          v-model="search.createTime"
          :show-time="{ format: 'HH:mm:ss' }"
          value-format="YYYY-MM-DD HH:mm:ss"
          :placeholder="['开始日期', '结束日期']"
        />
      </star-condition-cell>
      <star-condition-cell label="标签">
        <a-tree-select
          v-model="search.tags"
          style="width: 100%"
          :tree-data="tagTreeData"
          tree-checkable
          allow-clear
          placeholder="请选择标签"
          :treeCheckStrictly="true"
        />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap">
      <div class="table-wrap-header">
        <div class="table-wrap-header-left">
            <div class="table-wrap-header-left-item"
            :class="{'actived-item': activeType==='1'}"
            @click="changeTabFn('1')"
            >
            条件导出
          </div>
          <div class="table-wrap-header-left-item" 
            :class="{'actived-item':activeType==='2'}" 
            @click="changeTabFn('2')"
            >
            每日导出
          </div>
        </div>
        <div class="table-wrap-header-right" v-if="activeType==='1'">
            <a-dropdown type="primary" style="margin-left: 10px">
            <a-button type="primary"> 普通下载 <a-icon type="down" /> </a-button>
            <a-menu slot="overlay">
              <a-menu-item
                key="download-zip"
                style="margin-left: 10px"
                @click="handleDownloadBatch('zip')"
                >
                下载zip
              </a-menu-item>
              <a-menu-item
                key="download-rar"
                style="margin-left: 10px"
                @click="handleDownloadBatch('rar')"
              >
                下载rar
              </a-menu-item>

              <a-menu-item
                key="download-html"
                style="margin-left: 10px"
                @click="handleDownloadBatch('html')"
              >
                下载html
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-dropdown type="primary" style="margin-left: 10px">
            <a-button type="primary"> 全量下载 <a-icon type="down" /> </a-button>
            <a-menu slot="overlay">
              <a-menu-item
                key="download-all-zip"
                style="margin-left: 10px"
                @click="handleDownloadAll('zip')"
              >
                下载zip
              </a-menu-item>
              <a-menu-item
                key="download-all-rar"
                style="margin-left: 10px"
                @click="handleDownloadAll('zip')"
              >
                下载rar
              </a-menu-item>

              <a-menu-item
                key="download-all-html"
                style="margin-left: 10px"
                @click="handleDownloadAll('html')"
              >
                下载html
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
      <!-- <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns">
        
         <a-button type="primary" @click="handleDownloadBatch('csv')">普通下载</a-button> -->

        <!-- <a-dropdown type="primary" style="margin-left: 10px">
          <a-button type="primary"> 普通下载 <a-icon type="down" /> </a-button>
          <a-menu slot="overlay">
            <a-menu-item
              key="download-zip"
              style="margin-left: 10px"
              @click="handleDownloadBatch('zip')"
            >
              下载zip
            </a-menu-item>
            <a-menu-item
              key="download-rar"
              style="margin-left: 10px"
              @click="handleDownloadBatch('rar')"
            >
              下载rar
            </a-menu-item>

            <a-menu-item
              key="download-html"
              style="margin-left: 10px"
              @click="handleDownloadBatch('html')"
            >
              下载html
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->

        <!-- <a-button type="primary" @click="handleDownloadAll('csv')"></a-button> -->

        <!-- <a-dropdown type="primary" style="margin-left: 10px">
          <a-button type="primary"> 全量下载 <a-icon type="down" /> </a-button>
          <a-menu slot="overlay">
            <a-menu-item
              key="download-all-zip"
              style="margin-left: 10px"
              @click="handleDownloadAll('zip')"
            >
              下载zip
            </a-menu-item>
            <a-menu-item
              key="download-all-rar"
              style="margin-left: 10px"
              @click="handleDownloadAll('zip')"
            >
              下载rar
            </a-menu-item>

            <a-menu-item
              key="download-all-html"
              style="margin-left: 10px"
              @click="handleDownloadAll('html')"
            >
              下载html
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->
      <!-- </TableHeadIcons> -->

      <a-table
        v-show="activeType === '1'"
        :size="tableDensity"
        :columns="showColumns"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :row-key="(record) => record.id"
        :dataSource="dataSource"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="tags" slot-scope="text" :title="Array.isArray(text) ? text.join(',') : ' '">
          {{ Array.isArray(text) ? text.join(',') : ' ' }}
        </span>

        <span slot="isSensitive" slot-scope="isSensitive">
          <a-badge v-if="!isSensitive" color="green" text="否" />
          <a-badge v-else color="red" text="是" />
        </span>

        <span slot="content" slot-scope="content" v-html="content"></span>

        <span slot="titleT" slot-scope="titleT" v-html="titleT"></span>

        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleDetile(record)">
            <a-icon type="file-protect" /> 详情
          </a>
          <a href="javascript:;" @click="handleDetileUrl(record)" style="margin-left: 8px">
            <a-icon type="file-protect" /> 原文链接
          </a>
        </div>
      </a-table>
      <a-table
        v-show="activeType === '2'"
        :size="tableDensity"
        :columns="todayColumns"
        :loading="loading"
        :pagination="pagination2"
        @change="handleTableChange2"
        :row-key="(record) => record.id"
        :dataSource="todayData"
      >

      <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="fileSize" slot-scope="text">
        {{ bytesToSize(text) }}
      </span>
      <span slot="documentNum" slot-scope="text">
        {{ text.toLocaleString() }}
      </span>
      <span slot="downNum" slot-scope="text">
        {{ text.toLocaleString() }}
      </span>
      <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleDownload(record.id)">
            <a-icon type="download" /> 下载
          </a>
        </div>
      </a-table>
    </div>

    <a-modal
      title="媒体详情"
      :footer="null"
      :visible="visible"
      width="1010px"
      @cancel="visible = false"
    >
      <SelfMediaInfo :mediaData="mediaData" />
    </a-modal>
    <pdfViewer ref="pdfViewer"></pdfViewer>
  </div>
</template>

<script>
import SpiderTypeSelect from '@/components/SpiderTypeSelect/'
import SelfMediaInfo from '@/components/SelfMediaInfo/'
import CountrySelect from '@/components/CountrySelect/'
import LangSelect from '@/components/LangSelect/'
import pdfViewer from './pdfViewer'
import { contextPath } from '@/config/'
import { queryDataManageListApi, getDownStatisticsApi } from '@/api/DataCenter/DataManage'
import { searchTagsListApi } from '@/api/System/Tags'
import { mapMutations } from 'vuex'
export default {
  components: {
    SpiderTypeSelect,
    SelfMediaInfo,
    LangSelect,
    CountrySelect,
    pdfViewer
  },
  data() {
    return {
      loading: false,
      visible: false,
      search: {
        spiderClassType: [],
        countryCode: undefined,
        langCode: undefined,
        spiderName: undefined,
        title: undefined,
        searchContent: undefined,
        spiderId: undefined,
        publishTime: [],
        createTime: [],
        tags: []
      },
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '标题',
          dataIndex: 'title',
          ellipsis: true,
          scopedSlots: { customRender: 'titleT' },
          show: true,
          align: 'center'
        },
        {
          title: '内容',
          dataIndex: 'content',
          ellipsis: true,
          scopedSlots: { customRender: 'content' },
          show: true,
          align: 'center'
        },
        {
          title: '站点类型',
          dataIndex: 'spiderClassName',
          show: true,
          width: 90,
          align: 'center'
        },
        {
          title: '来源站点',
          dataIndex: 'source',
          show: true,
          width: 190,
          align: 'center'
        },
        {
          title: '语言',
          dataIndex: 'languageName',
          show: true,
          width: 90,
          align: 'center'
        },
        {
          title: '国家',
          dataIndex: 'countryName',
          show: true,
          width: 90,
          align: 'center'
        },
        {
          title: '标签',
          dataIndex: 'tags',
          scopedSlots: { customRender: 'tags' },
          show: true,
          width: 90,
          align: 'center',
          ellipsis: true
        },
        {
          title: '敏感词',
          dataIndex: 'isSensitive',
          scopedSlots: { customRender: 'isSensitive' },
          show: true,
          width: 90,
          align: 'center'
        },
        {
          title: '发布时间',
          dataIndex: 'publishTime',
          width: 150,
          show: true,
          align: 'center',
          sorter: true
        },
        {
          title: '采集日期',
          dataIndex: 'creationTime',
          show: true,
          width: 150,
          align: 'center',
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          width: 180,
          align: 'center'
        }
      ],
      tableDensity: 'middle',
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default',
        pageSizeOptions:['10','20','50','100','200','500']
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default',
        pageSizeOptions:['10','20','50','100','200','500']
      },
      todayColumns:[
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '日期',
          dataIndex: 'createTime',
          show: true,
          align: 'center'
        },
        {
          title: '内存',
          dataIndex: 'fileSize',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'fileSize' }
        },
        {
          title: '新闻条数',
          dataIndex: 'documentNum',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'documentNum' }
        },
        {
          title: '下载次数',
          dataIndex: 'downNum',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'downNum' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          width: 100,
          align: 'center'
        }
      ],
      todayData:[],
      sorter: {},
      selectedRowKeys: [],
      selectedRowContents: [],
      mediaData: {},
      tagTreeData: [],
      timeSort: null,
      activeType:'1',

    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  created() {
    this.queryDataManageList()
    this.getTagList()
  },

  methods: {
    ...mapMutations(['SET_LOADING']),

    async queryDataManageList() {
      let [publishStartTime, publishEndTime] = this.search.publishTime
      let [createStartTime, createEndTime] = this.search.createTime
      let tags = this.search.tags.map((item) => {
        return item.value
      })
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...JSON.parse(JSON.stringify(this.search)),
        publishStartTime,
        publishEndTime,
        createStartTime,
        createEndTime,
        spiderClassType: this.search.spiderClassType.length
          ? this.search.spiderClassType.length === 2
            ? this.search.spiderClassType[1]
            : this.search.spiderClassType[0]
          : undefined,
        tagIdStr: tags.join(',')
      }
      if (this.timeSort) {
        query['orderKey'] = this.timeSort.orderKey === 'publishTime' ? 'publicTime' : 'createTime'
        query['isAsc'] = this.timeSort.isAsc
      }

      delete query.publishTime
      delete query.createTime
      delete query.tags

      this.loading = true

      let res = await queryDataManageListApi(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code === 200) {
        this.dataSource = data.map((item) => {
          let isSensitive =
            (Array.isArray(item.contentSensitiveWordList) &&
              item.contentSensitiveWordList.length > 0) ||
            (Array.isArray(item.titleSensitiveWordList) && item.titleSensitiveWordList.length > 0)

          return {
            ...item,
            content: item.content
              ? item.content
                  .replaceAll('<warn>', '<font color="red">')
                  .replaceAll('</warn>', '</font>')
              : '',
            title: item.title
              ? item.title
                  .replaceAll('<warn>', '<font color="red">')
                  .replaceAll('</warn>', '</font>')
              : '',
            isSensitive
          }
        })
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },

    onSelectChange(selectedRowKeys, selectedRowContents) {
      this.selectedRowContents = selectedRowContents
      this.selectedRowKeys = selectedRowKeys
    },

    handleDetileUrl(record) {
      window.open(record.url)
    },

    handleDetile(record) {
      this.mediaData = {}
      if (record.index === 'selfmedia_standard') {
        this.mediaData = record
        this.visible = true
      } else {
        if (record.mediaType === 'document') {
          this.$refs.pdfViewer.openModel(record)
        } else {
          if (record.rowId) {
            window.open('/#/news-detail-view/' + record.rowId)
          } else {
            window.open('/#/news-detail-view/' + record.rowKey)
          }
        }
      }
    },

    //全量下载
    async handleDownloadAll(val) {
      if(this.pagination != null && this.pagination.total != null && this.pagination.total> 5000){
        this.$message.error("数据量过大！全量下载单次最大支持5000条数据")
        return
      }
      var str = '' 
      Object.keys(this.search).forEach((item) => {
        if (item !== 'spiderClassType' && item !== 'publishTime' && item !== 'createTime') {
          if (this.search[item]) {
            str += `${item}=${this.search[item]}&`
          }
        } else if (item === 'spiderClassType' && this.search.spiderClassType.length) {
          str += `${item}=${this.search.spiderClassType[0]}&`
        } else if (item === 'publishTime' && this.search.publishTime.length) {
          str += `publishStartTime=${this.search.publishTime[0]}&`
          str += `publishEndTime=${this.search.publishTime[1]}&`
        } else if (item === 'createTime' && this.search.createTime.length) {
          str += `createStartTime=${this.search.createTime[0]}&`
          str += `createEndTime=${this.search.createTime[1]}&`
        }
      })
      str += `downloadType=${val}&total=${this.pagination.total}`
      window.location.href = `${contextPath}/data/spider/storage/new/downloadAll?${str}`
    },

    //批量下载
    async handleDownloadBatch(val) {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请选择要下载数据项!')
        return
      }

      // 查询勾选内容是否包含敏感词：
      let isSensitive = false
      for (let i = 0; i < this.selectedRowContents.length; i++) {
        let item = this.selectedRowContents[i]
        if (
          (Array.isArray(item.contentSensitiveWordList) &&
            item.contentSensitiveWordList.length > 0) ||
          (Array.isArray(item.titleSensitiveWordList) && item.titleSensitiveWordList.length > 0)
        ) {
          isSensitive = true
          break
        }
      }
      if (isSensitive) {
        this.$confirm({
          title: '提示',
          content: '所选内容包含敏感词，是否确定下载？',
          onOk: () => {
            let ids = this.selectedRowKeys.join(',')
            window.location.href = `${contextPath}/data/spider/storage/new/downloadBatch?recordIdList=${ids}&downloadType=${val}`
          },
          onCancel() {}
        })
      } else {
        let ids = this.selectedRowKeys.join(',')
        // let res = await downloadBatchApi({recordIdList:ids})
        window.location.href = `${contextPath}/data/spider/storage/new/downloadBatch?recordIdList=${ids}&downloadType=${val}`
      }

      // let ids = this.selectedRowKeys.join(',')
      // window.location.href = `${contextPath}/data/spider/storage/new/downloadBatch?recordIdList=${ids}&downloadType=${val}`
      // this.SET_LOADING({ loading: true, text: '下载中...' })
      // let { key: fileTyle } = val
      // let query = {
      //   downType: fileTyle
      // }
      // let ids = this.selectedRowKeys.join(',')

      // this.SET_LOADING({ loading: false })
      // this.download('站点批量导出数据-' + new Date().getTime(), res)
    },

    handleSearch() {
      this.pagination.current = 1
      this.selectedRowKeys = []
      this.selectedRowContents = []
      this.queryDataManageList()
    },

    handleReset() {
      this.search.countryCode = undefined
      this.search.langCode = undefined
      this.search.spiderClassType = ''
      this.search.spiderName = ''
      this.search.title = ''
      this.search.searchContent = ''
      this.search.spiderId = undefined
      this.search.publishTime = []
      this.search.tags = []
      this.handleSearch()
    },

    //处理流下载
    download(fileName, data) {
      const blob = new Blob([data])
      const blobUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = fileName + '.' + 'xls'
      a.href = blobUrl
      a.click()
    },

    handleTableChange(pagination, filter, sorter) {
      const { field, order } = sorter
      if (order) {
        this.timeSort = {
          orderKey: field,
          isAsc: order === 'ascend' ? true : false
        }
      } else {
        this.timeSort = null
      }
      this.pagination = pagination
      this.queryDataManageList()
    },
    handleTableChange2(pagination){
      this.pagination2 = pagination
      this.getDownStatistics()
    },

    // 获取标签列表：
    async getTagList() {
      let { code, data } = await searchTagsListApi()
      if (code === 200) {
        this.tagTreeData = this.deepTags(data, -1)
      }
    },

    deepTags(data, parentId) {
      let list = []
      data.forEach((item) => {
        if (item.parentId === parentId) {
          let tag = {
            title: item.spiderTagName,
            key: item.spiderTagId,
            value: item.spiderTagId
          }
          // 判断下当前的tags的id是否在数组中作为其他项的parentId：
          let index = data.findIndex((i) => i.parentId === item.spiderTagId)
          if (index !== -1) {
            tag['children'] = this.deepTags(data, item.spiderTagId)
          } else {
            tag['children'] = []
          }
          list.push(tag)
        }
      })
      return list
    },

    changeTabFn(type){
      this.activeType = type
      if(type==='2'){
        this.getDownStatistics()
      }
    },

    // 内存计算
    bytesToSize(bytes) {
        if (bytes === 0) return '0 B';
        const k = 1000, // or 1024
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
    
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
    },

    // 获取每日导出
    getDownStatistics(){
      this.loading=true
       getDownStatisticsApi({pn:this.pagination2.current,pageSize:this.pagination2.pageSize}).then(res=>{
        const {data,extra} = res
        this.todayData = data
        this.pagination2.total = extra.page.pageCount || 0
      }).finally(()=>{
        this.loading=false
      })
    },
    // 下载每日导出
    handleDownload(id){
      window.location.href = `${contextPath}/data/down/statistics/download?id=${id}`
    }
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 20px;
  .search {
    padding: 20px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    .input-box {
      flex: 1;
    }
    .btn-box {
      width: 470px;
      margin-left: 20px;
    }
  }
  .table-wrap {
    background: #fff;
    margin-top: 20px;
    padding: 0px 20px;
    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      padding: 10px 0;
      &-left{
        display: flex;
        &-item{
          font-size:16px;
          color:#000;
          padding:0 10px;
          cursor: pointer;
          &:last-child{
            margin-left: 50px;
          }
        }
        .actived-item{
          color:rgb(24, 144, 255)!important
        }
      }
    }
  }
}
</style>
